
function toggleDisclaimerTextBlock(shouldShow, targetTextBlock, parentObject)
{
  var currentTargetTextBlockStyle = targetTextBlock.style.display;

  var currentShow = false;
  if(currentTargetTextBlockStyle == "block")
    currentShow = true;

  if(shouldShow == currentShow)
    return;

  console.log("targetTextBlock.innerText  = " + targetTextBlock.innerText);
  console.log("shouldShow  = " + shouldShow);

  var textBlockDisplay = "none";
  var tooltipArrowDisplay = "none";
  if(shouldShow) 
  {
    textBlockDisplay = "block";
    tooltipArrowDisplay = "inline";
  }
  
  targetTextBlock.style.display = textBlockDisplay;
  parentObject.querySelector(".icon-tooltip-arrow").style.display = tooltipArrowDisplay;
}

function productGridCardDisclaimerSetup(contentCard)
{
  
  var parentToAppendTo = contentCard.querySelector('.metafield-rich_text_field p');
  var disclaimerIcon = contentCard.querySelector('.icon-info-disclaimer');
  var disclaimerArrow =  contentCard.querySelector('.icon-tooltip-arrow');
  var disclaimerTextBlock = contentCard.querySelector('.collection-content-card-disclaimer-text-relative');
  var dislcaimerCloseButton = contentCard.querySelector('.collection-content-card-disclaimer-text-close svg');

  if(disclaimerIcon == null)
    return;
  
  parentToAppendTo.append(disclaimerIcon);
  parentToAppendTo.append(disclaimerArrow);


  console.log("disclaimerTextBlock.innerText  = " + disclaimerTextBlock.innerText);
  
  disclaimerIcon.addEventListener("click",  function(){ toggleDisclaimerTextBlock(true, disclaimerTextBlock, parentToAppendTo) });
  disclaimerIcon.addEventListener("mouseover",  function(){ toggleDisclaimerTextBlock(true, disclaimerTextBlock, parentToAppendTo) });
  dislcaimerCloseButton.addEventListener("click",  function(){ toggleDisclaimerTextBlock(false, disclaimerTextBlock, parentToAppendTo) });


}



addEventListener("DOMContentLoaded", (event) => {

  var contentCards = document.getElementsByClassName('collection-content-card-details-container');

  for(var nextContentCard of contentCards)
  {
    productGridCardDisclaimerSetup(nextContentCard);
  }
  
});